'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.blockPricing = twentyninetimes.blockPricing || function () {

	function init() {
		block_pricing();
	}

	function block_pricing() {
        var block_pricing = document.querySelector('.js-block-pricing-wrapper');
        
        if ( block_pricing ) {
            var input       = block_pricing.querySelector('.js-price-payment-input'),
                prices      = block_pricing.querySelectorAll('.js-block-pricing-price'),
                labels      = block_pricing.querySelectorAll('.js-block-pricing-label'),
                links       = block_pricing.querySelectorAll('.js-block-pricing-link');

            input.addEventListener('change', function(e) {
                e.stopPropagation();
                
                var payment     = input.checked == true ? 'annually' : 'monthly';

                prices.forEach(price => {
                    let new_price = price.getAttribute(payment);
                    price.innerHTML = new_price;
                });

                labels.forEach(label => {
                    let new_label = label.getAttribute(payment);
                    label.innerHTML = new_label;
                });

                links.forEach(link => {
                    let new_link = link.getAttribute(payment);
                    link.setAttribute('href', new_link);
                });
            });
        }
    }

	return {
		init : init
	};

}();